<script setup lang="ts">
  import { useOrdering } from '@/composition/use-ordering';
  import { inject } from 'vue';
  import ModalPosNewOrderSummaryItem from './ModalPosNewOrderSummaryItem.vue';

  const orderHelper = inject<ReturnType<typeof useOrdering>>('orderHelper');
</script>

<template>
  <div class="cart-items">
    <template v-if="!orderHelper.currentCartTotalItems.value">
      <div class="empty-cart">
        <div class="icon">
          <v-icon size="4rem">mdi-cart-outline</v-icon>
        </div>
        <div class="text">El pedido está vacío</div>
      </div>
    </template>
    <template v-else>
      <div class="items">
        <ModalPosNewOrderSummaryItem
          class="item"
          v-for="item in orderHelper.cart.value.cartItems"
          :key="item.index"
          :item="item"
        />
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
  .cart-items {
    @apply tw-w-full tw-h-full;

    .empty-cart {
      @apply tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-gray-400 tw-text-xl tw-w-full tw-h-full tw-py-4;
    }

    .items {
      @apply tw-divide-y tw-divide-dashed tw-divide-gray-200;
    }
  }
</style>
